import Remeeting from 'remeeting';

/* RMI stands for Remeeting Instance, and exports the singleton
 * remeeting instance that the rest of the app uses. This will replace
 * all of the individual instances in the other modules.
 *
 * For right now, the rmi will be stored in redux so that it is easy to
 * get a handle on in containers and modules, but it may be correct to have
 * this be a raw js module.
 *
 * The saved state from local storage will not include a Remeeting Instance,
 * as it will store authentication information in the session store. This
 * increases predictablity and isolates that behavoir to the session actions.
 *
 * REALLY IMPORTANT NOTE:
 * DO NOT DO ANYTHING EVEN REMOTELY RELATED TO AUTHENTICATION OR IDENTITY
 * MANAGEMENT OR SESSION STATE HERE. - COOPER, THE VENGEFUL
 */

/**
 * determineRemeetingApiBaseUrl
 * @param hostname String
 * @return baseUrl String
 * @NOTES: This is useful for developing against api-dev most of the time,
 *   which is nice because it means you can develop docker-less. However, it
 *   lets a dev develop against their local api, by using dockerhost, or against
 *   prod by using the devname.rmtg.co.
 */
export const determineRemeetingApiBaseUrl = (hostname) => {
  // When developing locally (dockerless) or when testing a www- (code for dev environment)
  // use the dev api
  if (hostname === 'localhost' || hostname.startsWith('www-')
      // ... or when testing from our dev servers (e.g. octo1.mod9.com or o2.mod9.co)
      || hostname.startsWith('octo') || hostname.endsWith('mod9.co')) {
    return 'https://api-dev.remeeting.com';
  }

  // When developing against dockerhost, use the docker api
  if (hostname === 'dockerhost') {
    return 'http://dockerhost:8082';
  }

  // When in production, or when developing against a production like dev enviroment like
  // adam.remeeting.com, use the production api
  return 'https://api.remeeting.com';
};

const config = { baseUrl: determineRemeetingApiBaseUrl(window.location.hostname) };
const initialState = new Remeeting(config);
initialState.origin = window.location.origin;

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
